
<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">QR Assets Details</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onClick()">X</button>
    </div>
</div>
<!--QR Asset Details -->

<div class="qr_asset_list">
    <div class="qr_asset_grid">
        <!-- <div>
            <div class="form-group"> -->

        <h6 class="asset_name">Entity Name</h6>
        <h6 class="asset_details">Sri Kalyana Chakravarti Memorial Educational Trust</h6>


        <!-- </div>
        </div> -->
        <!-- <div>
            <div class="form-group"> -->
        <h6 class="asset_name-1">Major Category</h6>
        <h6 class="asset_details-1">Electrical Equipment</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name">Minor Category</h6>
        <h6 class="asset_details">Fans</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name-1">QR Serial No.</h6>
        <h6 class="asset_details-1">20105947</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name">Date</h6>
        <h6 class="asset_details">05-06-2024</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name-1">Campus Name</h6>
        <h6 class="asset_details-1">Sumedha Bhavan</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name">Building Name</h6>
        <h6 class="asset_details">SKCT Vija Ramana Bhavan 1 Girls</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name-1">Building Fusion Code</h6>
        <h6 class="asset_details-1">106248</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name">Block No.</h6>
        <h6 class="asset_details">A</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name-1">Block Name</h6>
        <h6 class="asset_details-1">A Block</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name">Floor No.</h6>
        <h6 class="asset_details">First Floor</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name-1">Room No.</h6>
        <h6 class="asset_details-1">101</h6>
        <!-- </div>
        </div>
        <div>
            <div class="form-group"> -->
        <h6 class="asset_name">Room Type</h6>
        <h6 class="asset_details">Hostel Room</h6>
        <!-- </div>
        </div> -->
    </div>
</div>

<!-- Qr Asset text -->
<div class="qr_asset_text">
    <ul class="text_description">Asset Description
        <li>
            <textarea class="form-control" aria-label="With textarea"></textarea>
        </li>
    </ul>
    <ul class="text_description">Reason for Transfer
        <li>
            <textarea class="form-control" aria-label="With textarea"></textarea>
        </li>
    </ul>
    <ul class="text_description">Transport Cost details
        <li>
            <textarea class="form-control" aria-label="With textarea"></textarea>
        </li>
    </ul>
</div>

<div class="text-center">
    <button class="Edit" (click)="onClick()">Edit</button>
</div>